import { render, staticRenderFns } from "./BasicTicket.vue?vue&type=template&id=9870e14a&scoped=true"
import script from "./BasicTicket.vue?vue&type=script&lang=js"
export * from "./BasicTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9870e14a",
  null
  
)

export default component.exports